const siteHeaderEl = document.querySelector('.site-header');
const headerNavEl = siteHeaderEl.querySelector('.site-header__nav');

const searchBtn = document.querySelector("#searchBtn");
const closeBtn = document.querySelector("#closeSearch");
const searchForm = document.querySelector(".searchform");
const searchFormInput = document.querySelector(".search-form__input");
const tint = document.querySelector(".tint");

const desktopBreak = 1505; // Match variables.scss
let winWidth = window.innerWidth;

function handleWindowResize() {
  winWidth = window.innerWidth;
  calcOffsetHeight();
}

window.addEventListener('resize', handleWindowResize);

// Show searchbar on search icon click
$(searchBtn).on('click', function() {
    revealHeaderSearchBar();
});

// Open mobile menu on hamburger click
$('.site-header__nav-toggle').on('click', function() {
    openMobileMenu();
});

// Calculate CSS offset margin in the mobile menu on init
calcOffsetHeight();

// Navigate forwards in the mobile menu on link click
$('.nav-container > .menu-item-has-children > a').on('click', function(event) {
    navigateForwardsInMobileMenu(event);
});

// Navigate backwards in the mobile menu on arrow back click
$('.sub-menu-wrap > .sub-menu > .menu-item > a').on('click', function(event) {
    navigateBackwardsInMobileMenu(event);
});

// Show desktop menu on link click
$('#main-nav .nav-container > li.menu-item-has-children').each(function () {
    $(this).on('click', function () {
        showMegaMenuDesktop($(this));
    });
});

/**
 * Show mobile menu function
 */
function openMobileMenu() {
    document.body.classList.toggle('stop-scrolling');
    siteHeaderEl.classList.toggle('site-header--menu-open');

    const hidden = headerNavEl.getAttribute('aria-hidden');
    headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');
    tint.classList.toggle('tint-active');

    // Navigate backwards / clear sub menu if closing the menu
    if(!$('.site-header').hasClass('site-header--menu-open')) {
        $('.nav-container .menu-item').removeClass('inactive-menu-item');
        $('.nav-container .menu-item').removeClass('active-menu-item');
        $('.nav-container .active').removeClass('active');
        $('.nav-container .active-sub-menu').removeClass('active-sub-menu');
        $('.site-header__nav--meta').removeClass('hide-meta'); // Show meta buttons again / reset
    }
}

/**
 * Visar sökrutan i header
 */
function revealHeaderSearchBar() {
    searchForm.classList.toggle('active');
    searchFormInput.focus();
    tint.classList.toggle('tint-active');

    if (winWidth > 1386) {
        headerNavEl.classList.toggle('hidden');
    }

    // Add event listener for escape key
    document.addEventListener('keydown', function (event) {
        if (event.keyCode === 27) {
            tint.classList.remove('tint-active');
            searchForm.classList.remove('active');
            searchFormInput.blur();

            if (winWidth > 1386) {
                headerNavEl.classList.remove('hidden');
            }

        }
    });

    // Hide search bar on tint click
    tint.addEventListener("click", function () {
        tint.classList.remove('tint-active');
        searchForm.classList.remove('active');
        searchFormInput.blur();

        if (winWidth > 1386) {
            headerNavEl.classList.remove('hidden');
        }

    });

    // Hide search bar on close button click
    closeBtn.addEventListener("click", function () {
        tint.classList.remove('tint-active');
        searchForm.classList.remove('active');
        searchFormInput.blur();

        if (winWidth > 1386) {
            headerNavEl.classList.remove('hidden');
        }
    });
}

function calcOffsetHeight() {
    const liHeight = $('#main-nav ul > .menu-item').outerHeight(true);

    $('.sub-menu-wrap').each(function () {
        if (winWidth < desktopBreak) {
            const amount = ($(this).parent().prevAll('.menu-item').length);
            $(this).css('top', '-' + liHeight * amount + 'px');
        } else {
            $(this).css('top', '77px');
        }
    });
}

function navigateForwardsInMobileMenu(event) {
    event.preventDefault();
    calcOffsetHeight();
    // Drop down button in mobile menu
    if (winWidth < desktopBreak) {
        let target = $(event.currentTarget);
        if (target.parent().hasClass('active')) { //hide
            target.parent().children('.sub-menu-wrap').hide();
            target.parent().toggleClass('active-menu-item');
            $('li.menu-item:not(.active)').removeClass('inactive-menu-item');
            $('.site-header__nav--meta').removeClass('hide-meta'); // Show meta buttons again
        } else { // show
            target.parent().addClass('active');
            target.parent().addClass('active-sub-menu');
            target.parent().children('.sub-menu-wrap').css('display', 'flex');
            target.parent().toggleClass('active-menu-item');

            $('li.menu-item.active li.menu-item').addClass('active'); // Add active class to all li in sub menu child
            $('li.menu-item:not(.active)').addClass('inactive-menu-item');
            $('.site-header__nav--meta').addClass('hide-meta');
        }
    }
}

function navigateBackwardsInMobileMenu(event) {
    event.preventDefault();

    // Drop down button in mobile menu
    if (winWidth < desktopBreak) {
        let target = $(event.currentTarget);
        target.parent().removeClass('active'); // clicked anchor link
        $('.nav-container .menu-item').removeClass('inactive-menu-item');
        $('.nav-container .menu-item').removeClass('active-menu-item');
        $('.nav-container .active').removeClass('active');
        $('.nav-container .active-sub-menu').removeClass('active-sub-menu');
        $('.site-header__nav--meta').removeClass('hide-meta'); // Show meta buttons again
    }
}

/**
 * Mega menu desktop
 */
function showMegaMenuDesktop(element) {
    if (winWidth >= desktopBreak) {
        // Hide menu
        if (element.hasClass('active-sub-menu')) {
            element.removeClass('active-sub-menu');
            element.children('.sub-menu-wrap').removeClass('active-background');
            $('.latest-news-holder.header-version').removeClass('active-el'); 
            $('.tint').removeClass('tint-active');
            console.log('test2');
        }
        // Show menu
        else {
            $('.menu-item-has-children.active-sub-menu').each(function () { // hide menu
                $(this).removeClass('active-sub-menu');
                $(this).children('.sub-menu-wrap').removeClass('active-background');
                $('.latest-news-holder.header-version').removeClass('active-el');
            });
            element.addClass('active-sub-menu'); // Show menu
            element.children('.sub-menu-wrap').addClass('active-background'); // Show menu
            $('.latest-news-holder.header-version').addClass('active-el'); // Show menu
            $('.tint').addClass('tint-active');
            console.log('test3');
        }

        // Prevent closing the menu when clicking on .glide__slide.news-object
        $('.glide__slide.news-object, .glide__bullet').on('click', function(event) {
            event.stopPropagation(); // Stop the click from propagating and closing the menu
        });

        // Close menu when clicking outside, but not on .glide__slide.news-object
        $('.tint').on('click', function() {
            $('.menu-item').removeClass('active-sub-menu');
            $('.active-background').removeClass('active-background');
            $('.active-el').removeClass('active-el'); 
            $('.tint').removeClass('tint-active');
            console.log('test');
        });
    }
}

$('.menu-item-has-children .sub-menu:after').on('click', function () {
    if (winWidth >= desktopBreak) {
        $('.menu-item-has-children.active-sub-menu').removeClass('active-sub-menu');
    }
});